import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import TopNavbar from '../components/TopNavbar';
import LinkPaster from '../components/helpers/LinkPaster';
import ProjectCable from '../components/helpers/ProjectCable';
import Notifications from '../components/notifications/Notifications';
import Loading from '../components/helpers/Loading';

const mapStateToProps = state => ({ projectLoading:state.loaders.currentProject });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

class AuthPage extends Component {
  
  render() {
    const {projectLoading, children} = this.props
    return (<React.Fragment>
      <TopNavbar />
      <LinkPaster />
      <ProjectCable />
      <Notifications />
      
      {projectLoading === true ? <Loading text="Loading the project..." /> : <React.Fragment>
        {children}
      </React.Fragment>}
    </React.Fragment>)
  }
}


export default connect(mapStateToProps, matchDispatchToProps)(AuthPage);


// WEBPACK FOOTER //
// ./src/containers/AuthPage.js